export const locale___SbLandingPage = {
	'map_is_loading': {
		de_de: 'Die Karte wird geladen...',
		en_us: 'The map is loading...',
		es_es: 'El mapa se está cargando...',
		fr_fr: 'La carte est en cours de chargement...',
		it_it: 'La mappa sta caricando...',
	},
};